
import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography
} from '@mui/material';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { TransferList } from '../common/TransferList/TransferList';

export const ExportData = ({ open, onClose, fields, contracts }) => {
  const [selectedFields, setSelectedFields] = useState([]);

  const labelMap = {
    name: "CONTRATO",
    start_date: "FECHA DE INICIO",
    end_date: "FECHA DE VENCIMIENTO",
    equipment_devices: "DETALLES DE EQUIPOS",
    comments: "COMENTARIOS",
    cm_devices: "Nº CM",
    nodes_devices: "Nº NODOS",
    telemeasures_devices: "Nº TELEMEDIDAS",
    responsible: "PERSONA RESPONSABLE",
    contact: "EMAIL Y TELÉFONO",
    contractor: "CONTRATISTA",
    contract_price: "COSTE ANUAL",
    node_price: "PRECIO POR NODO",
    cm_price: "PRECIO POR CM",
    telemeasures_price: "PRECIO POR TELEMEDIDA",
    contract_state: "ESTADO",
  };

  const columnWidths = {
    name: 20,
    start_date: 15,
    end_date: 15,
    equipment_devices: 40,
    comments: 40,
    cm_devices: 10,
    nodes_devices: 10,
    telemeasures_devices: 15,
    contract_state: 10,
    responsible: 20,
    contact: 25,
    contractor: 20,
    contract_price: 15,
    node_price: 15,
    cm_price: 15,
    telemeasures_price: 18
  };



  const handleDownload = () => {
    if (selectedFields.length === 0) return;

    const headers = selectedFields.map(key => labelMap[key] || key);
    const dataRows = contracts.map(contract =>
      selectedFields.map(key => {
        const value = contract[key];
        if (key === 'start_date' || key === 'end_date') {
          // Convertimos fecha a objeto Date si es válida
          const date = new Date(value);
          return isNaN(date.getTime()) ? '' : date;
        }
        return value ?? '';
      })
    );

    const worksheetData = [headers, ...dataRows];
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

    // Anchos de columnas personalizados
    worksheet['!cols'] = selectedFields.map(key => ({
      wch: columnWidths[key] || 15
    }));

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Contratos');

    const xlsxBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([xlsxBuffer], { type: 'application/octet-stream' });
    saveAs(blob, 'contratos_exportados.xlsx');

    onClose();
  };

  const formattedFields = Object.entries(fields).map(([key, label]) => ({
    key,
    label
  }));

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Seleccione datos para exportar</DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Use las flechas para seleccionar qué datos desea exportar.
        </Typography>
        <TransferList
          items={formattedFields}
          selected={selectedFields}
          setSelected={setSelectedFields}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button variant="contained" onClick={handleDownload}>Descargar Excel</Button>
      </DialogActions>
    </Dialog>
  );
};
